export const tabs = [
  {
    id: 1,
    text: "All",
  },
  {
    id: 2,
    text: "FURNITURE",
  },
  {
    id: 3,
    text: "DECORATION",
  },
  {
    id: 4,
    text: "LIGHTING",
  },
];
